import {
  motivateMonitorWorkshopACT as acts
} from '../../constants/vuexActions'
import {
  motivateMonitorWorkshopVars as vars
} from '../../constants/vuexVariables'
import {
  motivateMonitorWorkshopMUT as muts
} from '../../constants/vuexMutations'
import apolloClient from '../../apolloClient'
import workshopsQueries from '../../graphql/workshops'

const moduleMotivateMonitorWorkshop = {
  namespaced: true,
  state () {
    return {
      [vars.cookingTargetCurrentStats]: null
      // {
      //   earlierHours: {
      //     inTarget: 0,
      //     outOfTarget: 0,
      //     notKnown: 0
      //   },
      //   currentHour: {
      //     inTarget: 0,
      //     outOfTarget: 0,
      //     notKnown: 0
      //   }
      // }
    }
  },
  actions: {
    [acts.requestTargetStats] ({commit, dispatch}) {
      // let result = null
      apolloClient.query({
        query: workshopsQueries.TARGET_NOT_TARGET_COUNT,
        fetchPolicy: 'network-only'
      }).then(res => {
        commit(muts.setCookingTargetCurrentStats, res.data.statsCookerMotivationStatefull)
      })
    }
  },
  mutations: {
    [muts.setCookingTargetCurrentStats] (state, payload) {
      state[vars.cookingTargetCurrentStats] = payload
    }
  },
  getters: {

  },
  modules: {
  }
}

export default moduleMotivateMonitorWorkshop



// WEBPACK FOOTER //
// ./src/vuex/submodules/motivateMonitorWorkshop.js